import { useState } from 'react';

const TEMPLATES = [
  {
    id: 1, name: 'Classic', color: '#1a1a1a', accent: '#333',
    desc: 'Traditional black & white',
    fields: ['name', 'email', 'phone', 'location', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#fff', header: '#1a1a1a', sidebar: null }
  },
  {
    id: 2, name: 'Modern', color: '#7C3AED', accent: '#a78bfa',
    desc: 'Purple sidebar layout',
    fields: ['name', 'email', 'phone', 'location', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#fff', header: '#7C3AED', sidebar: '#7C3AED' }
  },
  {
    id: 3, name: 'Minimal', color: '#0F766E', accent: '#14b8a6',
    desc: 'Clean & simple lines',
    fields: ['name', 'email', 'phone', 'location', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#fff', header: '#fff', sidebar: null }
  },
  {
    id: 4, name: 'Bold', color: '#1E3A5F', accent: '#F59E0B',
    desc: 'Navy blue with gold accents',
    fields: ['name', 'email', 'phone', 'location', 'linkedin', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#fff', header: '#1E3A5F', sidebar: null }
  },
  {
    id: 5, name: 'Professional', color: '#B91C1C', accent: '#ef4444',
    desc: 'Red corporate style',
    fields: ['name', 'email', 'phone', 'location', 'linkedin', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#fff', header: '#B91C1C', sidebar: '#FEF2F2' }
  },
  {
    id: 6, name: 'Executive', color: '#064E3B', accent: '#10b981',
    desc: 'Dark green premium look',
    fields: ['name', 'email', 'phone', 'location', 'linkedin', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#fff', header: '#064E3B', sidebar: null }
  },
  {
    id: 7, name: 'Creative', color: '#9D174D', accent: '#ec4899',
    desc: 'Pink creative design',
    fields: ['name', 'email', 'phone', 'location', 'photo', 'summary', 'experience', 'skills'],
    preview: { bg: '#fff', header: '#9D174D', sidebar: '#FDF2F8' }
  },
  {
    id: 8, name: 'Tech', color: '#1E3A5F', accent: '#38bdf8',
    desc: 'Dark tech developer style',
    fields: ['name', 'email', 'phone', 'linkedin', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#0f172a', header: '#0f172a', sidebar: null }
  },
  {
    id: 9, name: 'Elegant', color: '#78350F', accent: '#d97706',
    desc: 'Gold & brown elegant',
    fields: ['name', 'email', 'phone', 'location', 'linkedin', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#FFFBEB', header: '#78350F', sidebar: null }
  },
  {
    id: 10, name: 'Fresh', color: '#1D4ED8', accent: '#60a5fa',
    desc: 'Blue modern fresh look',
    fields: ['name', 'email', 'phone', 'location', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#fff', header: '#1D4ED8', sidebar: '#EFF6FF' }
  },
  {
    id: 11, name: 'BlueSide', color: '#4a6a8a', accent: '#dce6f0',
    desc: 'Blue sidebar with photo frame',
    fields: ['name', 'email', 'phone', 'location', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#fff', header: '#dce6f0', sidebar: '#dce6f0' }
  },
  {
    id: 12, name: 'Cream', color: '#8B2500', accent: '#c0633a',
    desc: 'Cream 3-column elegant',
    fields: ['name', 'email', 'phone', 'location', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#faf8f0', header: '#faf8f0', sidebar: null }
  },
  {
    id: 13, name: 'Mauve', color: '#5C3D3D', accent: '#8B6B6B',
    desc: 'Pink mauve two-column',
    fields: ['name', 'email', 'phone', 'location', 'photo', 'summary', 'experience', 'education', 'skills'],
    preview: { bg: '#f5ede8', header: '#f5ede8', sidebar: '#ede0d8' }
  },
];

// Mini resume thumbnail preview
function TemplateThumbnail({ template, selected, onClick }) {
  const { preview, name, desc, color } = template;

  return (
    <div
      onClick={onClick}
      style={{
        cursor: 'pointer',
        border: selected ? `2px solid ${color}` : '2px solid #2a2a2a',
        borderRadius: '10px',
        overflow: 'hidden',
        transition: 'all 0.2s',
        background: '#1a1a1a',
        transform: selected ? 'scale(1.03)' : 'scale(1)',
        boxShadow: selected ? `0 0 16px ${color}44` : 'none',
      }}
    >
      {/* Mini resume preview */}
      <div style={{ height: '140px', background: preview.bg, position: 'relative', overflow: 'hidden' }}>
        {/* Header bar */}
        <div style={{ background: preview.header, height: preview.sidebar ? '100%' : '36px', width: preview.sidebar ? '38%' : '100%', position: 'absolute', top: 0, left: 0 }}>
          {/* Avatar circle */}
          <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: 'rgba(255,255,255,0.3)', margin: '7px 8px' }} />
          {/* Name line */}
          <div style={{ height: '5px', background: 'rgba(255,255,255,0.6)', width: '60%', borderRadius: '3px', margin: '4px 8px' }} />
          <div style={{ height: '3px', background: 'rgba(255,255,255,0.3)', width: '80%', borderRadius: '3px', margin: '4px 8px' }} />
          {!preview.sidebar && null}
          {preview.sidebar && (
            <>
              <div style={{ height: '3px', background: 'rgba(255,255,255,0.2)', width: '70%', borderRadius: '3px', margin: '8px 8px 4px' }} />
              <div style={{ height: '3px', background: 'rgba(255,255,255,0.2)', width: '60%', borderRadius: '3px', margin: '4px 8px' }} />
              <div style={{ height: '3px', background: 'rgba(255,255,255,0.2)', width: '70%', borderRadius: '3px', margin: '4px 8px' }} />
            </>
          )}
        </div>

        {/* Content area */}
        {!preview.sidebar ? (
          <div style={{ padding: '44px 10px 8px' }}>
            <div style={{ height: '3px', background: '#ddd', borderRadius: '2px', marginBottom: '6px' }} />
            <div style={{ height: '3px', background: '#eee', width: '90%', borderRadius: '2px', marginBottom: '3px' }} />
            <div style={{ height: '3px', background: '#eee', width: '80%', borderRadius: '2px', marginBottom: '8px' }} />
            <div style={{ height: '3px', background: '#ddd', width: '40%', borderRadius: '2px', marginBottom: '6px' }} />
            <div style={{ height: '3px', background: '#eee', width: '95%', borderRadius: '2px', marginBottom: '3px' }} />
            <div style={{ height: '3px', background: '#eee', width: '85%', borderRadius: '2px', marginBottom: '3px' }} />
            <div style={{ height: '3px', background: '#eee', width: '90%', borderRadius: '2px', marginBottom: '8px' }} />
            <div style={{ display: 'flex', gap: '4px' }}>
              {[1,2,3,4].map(i => <div key={i} style={{ height: '12px', width: '28px', background: '#f0f0f0', borderRadius: '6px' }} />)}
            </div>
          </div>
        ) : (
          <div style={{ position: 'absolute', left: '38%', top: 0, right: 0, padding: '10px 10px' }}>
            <div style={{ height: '3px', background: color + '44', width: '50%', borderRadius: '2px', marginBottom: '6px' }} />
            <div style={{ height: '3px', background: '#eee', width: '90%', borderRadius: '2px', marginBottom: '3px' }} />
            <div style={{ height: '3px', background: '#eee', width: '80%', borderRadius: '2px', marginBottom: '8px' }} />
            <div style={{ height: '3px', background: color + '44', width: '50%', borderRadius: '2px', marginBottom: '6px' }} />
            <div style={{ height: '3px', background: '#eee', width: '85%', borderRadius: '2px', marginBottom: '3px' }} />
            <div style={{ height: '3px', background: '#eee', width: '75%', borderRadius: '2px', marginBottom: '3px' }} />
            <div style={{ height: '3px', background: '#eee', width: '90%', borderRadius: '2px', marginBottom: '8px' }} />
          </div>
        )}
      </div>

      {/* Label */}
      <div style={{ padding: '8px 12px', background: selected ? color : '#1a1a1a' }}>
        <div style={{ fontSize: '12px', fontWeight: '600', color: selected ? '#fff' : '#ccc', fontFamily: "'Inter', sans-serif" }}>{name}</div>
        <div style={{ fontSize: '10px', color: selected ? 'rgba(255,255,255,0.7)' : '#666', fontFamily: "'Inter', sans-serif" }}>{desc}</div>
      </div>
    </div>
  );
}

export default function TemplateSelector({ onSelect }) {
  const [selected, setSelected] = useState(null);

  const handleSelect = (template) => {
    setSelected(template.id);
  };

  const handleStart = () => {
    if (!selected) return;
    const template = TEMPLATES.find(t => t.id === selected);
    onSelect(template);
  };

  return (
    <div className="ts-overlay" style={styles.overlay}>
      <style>{`
        .template-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 12px;
        }
        @media (max-width: 900px) {
          .template-grid { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 560px) {
          .template-grid { grid-template-columns: repeat(2, 1fr); gap: 10px; }
        }
        @media (max-width: 480px) {
          .ts-overlay { padding: 0 !important; }
          .ts-modal { max-height: 100vh !important; border-radius: 0 !important; }
          .ts-header { padding: 20px 16px 14px !important; }
          .ts-grid-wrap { padding: 16px !important; }
          .ts-footer { padding: 14px 16px !important; flex-direction: column !important; align-items: stretch !important; gap: 10px; }
          .ts-start-btn { width: 100%; }
        }
      `}</style>
      <div className="ts-modal" style={styles.modal}>
        <div className="ts-header" style={styles.header}>
          <span style={styles.icon}>✦</span>
          <h2 style={styles.title}>Choose Your Resume Template</h2>
          <p style={styles.subtitle}>Pick a design — the AI will ask you the right questions for it</p>
        </div>

        <div className="ts-grid-wrap" style={styles.grid}>
          <div className="template-grid">
            {TEMPLATES.map(t => (
              <TemplateThumbnail
                key={t.id}
                template={t}
                selected={selected === t.id}
                onClick={() => handleSelect(t)}
              />
            ))}
          </div>
        </div>

        <div className="ts-footer" style={styles.footer}>
          {selected && (
            <div style={styles.selectedInfo}>
              <span style={{ color: '#a78bfa' }}>✓</span>
              <span style={{ color: '#ccc', fontSize: '13px' }}>
                {TEMPLATES.find(t => t.id === selected)?.name} template selected
              </span>
            </div>
          )}
          <button
            className="ts-start-btn"
            style={{ ...styles.startBtn, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'not-allowed' }}
            onClick={handleStart}
            disabled={!selected}
          >
            Start Building My Resume →
          </button>
        </div>
      </div>
    </div>
  );
}

export { TEMPLATES };

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: '12px', backdropFilter: 'blur(4px)',
    boxSizing: 'border-box',
  },
  modal: {
    background: '#111', border: '1px solid #222', borderRadius: '16px',
    width: '100%', maxWidth: '860px', maxHeight: '90vh',
    overflow: 'hidden', display: 'flex', flexDirection: 'column',
  },
  header: {
    padding: '28px 32px 20px', borderBottom: '1px solid #1e1e1e', textAlign: 'center',
  },
  icon: { fontSize: '24px', color: '#a78bfa', display: 'block', marginBottom: '8px' },
  title: { fontSize: '22px', fontWeight: '700', color: '#f0f0f0', margin: '0 0 6px', fontFamily: "'Inter', sans-serif" },
  subtitle: { fontSize: '13px', color: '#666', margin: 0, fontFamily: "'Inter', sans-serif" },
  grid: {
    padding: '24px 28px', overflowY: 'auto', flex: 1,
  },
  footer: {
    padding: '16px 28px', borderTop: '1px solid #1e1e1e',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    background: '#0f0f0f',
  },
  selectedInfo: { display: 'flex', alignItems: 'center', gap: '8px' },
  startBtn: {
    background: '#a78bfa', color: '#fff', border: 'none',
    borderRadius: '10px', padding: '12px 28px', fontSize: '14px',
    fontWeight: '600', fontFamily: "'Inter', sans-serif",
  },
};
